export const REQUEST_MANIFEST = 'REQUEST_MANIFEST'
export const RECEIVE_MANIFEST = 'RECEIVE_MANIFEST'
export const FAILED_MANIFEST = 'FAILED_MANIFEST'

import 'isomorphic-fetch'

import { getBaseUrl } from '../utils'
import { basicGet } from '../utils/api'
import { getErrorAction } from '../utils/actions'

export function receiveManifest(response) {
  return {
    type: RECEIVE_MANIFEST,
    payload: {
      manifest: response.manifest
    }
  }
}

export function requestManifest() {
  return {
    type: REQUEST_MANIFEST
  }
}

export function failedManifest(error) {
  return getErrorAction(FAILED_MANIFEST, error)
}

export function fetchManifest() {
  return (dispatch, getState) => {
    const state = getState()
    const url = `${getBaseUrl()}/quest_maker/api/manifest`
    return basicGet(
      state,
      dispatch,
      url,
      requestManifest,
      receiveManifest,
      failedManifest
    )
  }
}



// WEBPACK FOOTER //
// ./src/actions/manifest.js